/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function n(n){return n}function r(r){return n(1e3*r)}function t(n){return n}function u(n){return t(.001*n)}export{n as Milliseconds,r as MillisecondsFromSeconds,t as Seconds,u as SecondsFromMilliseconds};
